import { useEffect, useState } from 'react';

/**
 * Shows a sticky banner when a new service worker version is available.
 * User can click "Update" to reload and activate the new version.
 */
export default function SwUpdateBanner() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [offlineSynced, setOfflineSynced] = useState(0);

  useEffect(() => {
    const handleUpdate = () => setUpdateAvailable(true);
    const handleMessage = (e) => {
      if (e.detail?.type === 'OFFLINE_SYNC_COMPLETE' && e.detail.synced > 0) {
        setOfflineSynced(e.detail.synced);
        setTimeout(() => setOfflineSynced(0), 5000);
      }
    };

    window.addEventListener('aiviora:sw-update', handleUpdate);
    window.addEventListener('aiviora:sw-message', handleMessage);
    return () => {
      window.removeEventListener('aiviora:sw-update', handleUpdate);
      window.removeEventListener('aiviora:sw-message', handleMessage);
    };
  }, []);

  const handleUpdate = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistration().then((reg) => {
        if (reg?.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        window.location.reload();
      });
    }
  };

  if (offlineSynced > 0) {
    return (
      <div className="sw-banner sw-banner--sync">
        {offlineSynced} offline sale{offlineSynced > 1 ? 's' : ''} synced successfully
      </div>
    );
  }

  if (!updateAvailable) return null;

  return (
    <div className="sw-banner sw-banner--update">
      <span>A new version of Aiviora is ready.</span>
      <button className="sw-banner__btn" onClick={handleUpdate}>
        Update now
      </button>
    </div>
  );
}
